import { lazy } from "react";

const Dashboard = lazy(() => import("../pages/Dashboard"));
const Locations = lazy(() => import("../pages/Locations"));
const Options = lazy(() => import("../pages/Options"));
const Categories = lazy(() => import("../pages/Categories"));
const Products = lazy(() => import("../pages/Products"));
const AddProduct = lazy(() => import("../pages/AddProduct"));
const EditVariant = lazy(() => import("../pages/EditVariant"));
const Customers = lazy(() => import("../pages/Customers"));
const Orders = lazy(() => import("../pages/Orders"));
const FulfilmentOptions = lazy(() => import("../pages/FulfilmentOptions"));
const ChatbotConfiguration = lazy(() => import("../pages/ChatbotConfiguration"));
const EditProfile = lazy(() => import("../pages/EditProfile"));
const Notifications = lazy(() => import("../pages/Notifications"));
const Admins = lazy(() => import("../pages/Admins"));
const POSConfiguration = lazy(() => import("../pages/POSConfiguration"));
const Integrations = lazy(() => import("../pages/Integrations"));
const SyncSchedule = lazy(() => import("../pages/SyncSchedule"));
const RunHistory = lazy(() => import("../pages/RunHistory"));
const BulkUploadHistory = lazy(()=> import ("../pages/BulkUploadHistory"));

const routes = [
  {
    path: "/dashboard",
    component: Dashboard,
  },
  {
    path: "/locations",
    component: Locations,
  },
  {
    path: "/options",
    component: Options,
  },
  {
    path: "/categories",
    component: Categories,
  },
  {
    path: "/products",
    component: Products,
  },
  {
    path: "/add-product",
    component: AddProduct,
  },
  {
    path: "/edit-product/:productId",
    component: AddProduct,
  },
  {
    path: "/edit-variant",
    component: EditVariant,
  },
  {
    path: "/orders",
    component: Orders,
  },
  {
    path: "/orders/:orderId",
    component: Orders,
  },
  {
    path: "/fulfillment",
    component: FulfilmentOptions,
  },
  {
    path: "/chatbot-configuration",
    component: ChatbotConfiguration,
  },
  {
    path: "/customers",
    component: Customers,
  },
  {
    path: "/edit-profile",
    component: EditProfile,
  },
  {
    path: "/notifications",
    component: Notifications,
  },
  {
    path: "/admins",
    component: Admins,
  },
  {
    path: "/pos-configuration",
    // component: POSConfiguration,
    component: Integrations,
  },
  {
    path: "/sync-schedule",
    component: SyncSchedule,
  },
  {
    path: "/sync-schedule/:integrationName",
    component: SyncSchedule,
  },
  {
    path: "/run-history",
    component: RunHistory,
  },
  {
    path: "/run-history/:integrationName",
    component: RunHistory,
  },
  {
    path: "/bulk-upload-history",
    component: BulkUploadHistory,
  },
];

export default routes;
